class GetTimer {
  constructor(){
  }
  time1 = new Date()
  time2 = new Date()
  time3 = new Date()
  time4 = new Date()
  time5 = new Date()

  setTime1 = () => this.time1 = new Date()
  setTime2 = () => this.time2 = new Date()
  setTime3 = () => this.time3 = new Date()
  setTime4 = () => this.time4 = new Date()
  setTime5 = () => this.time5 = new Date()
  
  getTimer1 = () => (new Date().getTime() - this.time1.getTime()) / 1000
  getTimer2 = () => (new Date().getTime() - this.time2.getTime()) / 1000
  getTimer3 = () => (new Date().getTime() - this.time3.getTime()) / 1000
  getTimer4 = () => (new Date().getTime() - this.time4.getTime()) / 1000
  getTimer5 = () => (new Date().getTime() - this.time5.getTime()) / 1000
}

export default GetTimer